import {} from "../../../utils/constants";
import {
  LOCAL_STORAGE_REFRESH_TOKEN,
  LOCAL_STORAGE_ACCESS_TOKEN,
} from "../../../utils/constants";
import {
  assignSubscriptionPlan,
  disableAutomaticSubscriptionRenewal,
  validatePayment,
} from "../subscriptions/asyncThunks";
import {
  addRoleToUser,
  createBusinessUserRole,
  createCustomer,
  editCompanyInfo,
  editCompanyProfile,
  fetchBusinessUserInfo,
  getAllBusinessUserRoles,
  getCustomers,
  getInvitationLink,
  logout,
  updateBusinessUserRole,
} from "./asyncThunks";

export const businessUserInfoBuilder = (builder) => {
  builder.addCase(fetchBusinessUserInfo.pending, (state) => {
    state.fetchBusinessUserInfoLoading = true;
  });
  builder.addCase(fetchBusinessUserInfo.fulfilled, (state, action) => {
    state.fetchBusinessUserInfoLoading = false;
    const {
      id,
      fullName,
      email,
      mobileNumber,
      role,
      company,
      tapPaymentCustomerId,
      verified,
      lang,
      businessUserRole,
    } = action.payload;
    state.id = id;
    state.fullName = fullName;
    state.email = email;
    state.mobileNumber = mobileNumber;
    state.role = role;
    state.company = company;
    state.tapPaymentCustomerId = tapPaymentCustomerId;
    state.verified = verified;
    state.loggedIn = true;
    state.lang = lang;
    state.businessUserRole = businessUserRole;
  });
  builder.addCase(fetchBusinessUserInfo.rejected, (state) => {
    state.fetchBusinessUserInfoLoading = false;
  });
};

export const invitationLinkBuilder = (builder) => {
  builder.addCase(getInvitationLink.pending, (state) => {
    state.gettingInvitationLink = true;
  });
  builder.addCase(getInvitationLink.fulfilled, (state, action) => {
    state.gettingInvitationLink = false;
    const invitationLink = action.payload;
    state.invitationLink = invitationLink;
  });
  builder.addCase(getInvitationLink.rejected, (state) => {
    state.gettingInvitationLink = false;
  });
};

export const editCompanyBuilder = (builder) => {
  builder.addCase(editCompanyInfo.pending, (state) => {
    state.editingCompanyInfo = true;
  });
  builder.addCase(editCompanyInfo.fulfilled, (state, action) => {
    state.editingCompanyInfo = false;
    const company = action.payload;
    state.company = company;
  });
  builder.addCase(editCompanyInfo.rejected, (state) => {
    state.editingCompanyInfo = false;
  });
};

export const editCompanyProfileBuilder = (builder) => {
  builder.addCase(editCompanyProfile.pending, (state) => {
    state.editingCompanyInfo = true;
  });
  builder.addCase(editCompanyProfile.fulfilled, (state, action) => {
    state.editingCompanyInfo = false;
    const businessUser = action.payload;
    state.company = businessUser.company;
    state.fullName = businessUser.fullName;
  });
  builder.addCase(editCompanyProfile.rejected, (state) => {
    state.editingCompanyInfo = false;
  });
};

export const logoutBuilder = (builder) => {
  builder.addCase(logout.pending, (state) => {
    state.loggedIn = false;
  });
  builder.addCase(logout.fulfilled, (state) => {
    localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
    state.loggedIn = false;
  });
  builder.addCase(logout.rejected, (state) => {
    localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
    state.loggedIn = false;
  });
};

export const disableAutomaticSubscriptionRenewalBuilder = (builder) => {
  builder.addCase(disableAutomaticSubscriptionRenewal.pending, (state) => {
    state.disableAutomaticSubscriptionRenewal.loading = true;
  });
  builder.addCase(disableAutomaticSubscriptionRenewal.fulfilled, (state) => {
    state.company.automaticSubscriptionRenewal = false;
    state.disableAutomaticSubscriptionRenewal.loading = false;
  });
  builder.addCase(
    disableAutomaticSubscriptionRenewal.rejected,
    (state, { payload }) => {
      state.disableAutomaticSubscriptionRenewal.loading = false;
    }
  );
};

export const assignSubscriptionPlanBuilder = (builder) => {
  builder.addCase(assignSubscriptionPlan.pending, (state) => {
    state.assignSubscriptionPlanLoading = true;
  });
  builder.addCase(assignSubscriptionPlan.fulfilled, (state, action) => {
    state.assignSubscriptionPlanLoading = false;
    const { packageType } = action.payload.data;
    if (packageType === "Free") {
      state.company = { ...state.company, packageType };
    }
  });
  builder.addCase(assignSubscriptionPlan.rejected, (state) => {
    state.assignSubscriptionPlanLoading = false;
  });
};

export const validatePaymentSubscriptionBuilder = (builder) => {
  builder.addCase(validatePayment.fulfilled, (state, action) => {
    const { data } = action.payload;

    if (data && data.packageType) {
      state.company = { ...state.company, packageType: data.packageType };
    }
  });
};

export const getCustomersBuilder = (builder) => {
  builder
    .addCase(getCustomers.pending, (state) => {
      state.customers.loading = true;
      state.customers.error = null;
    })
    .addCase(getCustomers.fulfilled, (state, action) => {
      state.customers.data = action.payload.data;
      state.customers.maxReached = action.payload.maxReached;
      state.customers.perPage = action.payload.perPage;
      state.customers.total = action.payload.total;
      state.customers.loading = false;
    })
    .addCase(getCustomers.rejected, (state) => {
      state.customers.loading = false;
    });
};

export const createCustomerBuilder = (builder) => {
  builder.addCase(createCustomer.pending, (state) => {
    state.createCustomerLoading = true;
  });
  builder.addCase(createCustomer.fulfilled, (state, { payload }) => {
    state.customers.data = [payload.data, ...state.customers.data];
    state.createCustomerLoading = false;
  });
  builder.addCase(createCustomer.rejected, (state, action) => {
    state.createCustomerLoading = false;
  });
};

export const getAllBusinessUserRolesBuilder = (builder) => {
  builder.addCase(getAllBusinessUserRoles.pending, (state) => {
    state.getAllBusinessUserRolesPending = true;
  });
  builder.addCase(getAllBusinessUserRoles.fulfilled, (state, { payload }) => {
    state.getAllBusinessUserRolesPending = false;
    state.businessUserRoles.data = payload.data;
    state.businessUserRoles.maxReached = payload.maxReached;
    state.businessUserRoles.perPage = payload.perPage;
    state.businessUserRoles.total = payload.total;
  });
  builder.addCase(getAllBusinessUserRoles.rejected, (state, action) => {
    state.getAllBusinessUserRolesPending = false;
  });
};

export const createBusinessUserRoleBuilder = (builder) => {
  builder.addCase(createBusinessUserRole.pending, (state) => {
    state.createBusinessUserRolePending = true;
  });
  builder.addCase(createBusinessUserRole.fulfilled, (state, { payload }) => {
    state.businessUserRoles.data = [payload, ...state.businessUserRoles.data];

    state.createBusinessUserRolePending = false;
  });
  builder.addCase(createBusinessUserRole.rejected, (state, action) => {
    state.createBusinessUserRolePending = false;
  });
};

export const updateBusinessUserRoleBuilder = (builder) => {
  builder.addCase(updateBusinessUserRole.pending, (state) => {
    state.updateBusinessUserRolePending = true;
  });
  builder.addCase(updateBusinessUserRole.fulfilled, (state, { payload }) => {
    state.updateBusinessUserRolePending = false;

    state.businessUserRoles.data = state.businessUserRoles.data.map((role) =>
      role.id === payload.id ? payload : role
    );
  });
  builder.addCase(updateBusinessUserRole.rejected, (state, action) => {
    state.updateBusinessUserRolePending = false;
  });
};

export const addRoleToUserBuilder = (builder) => {
  builder.addCase(addRoleToUser.pending, (state) => {
    state.addRoleToUserPending = true;
  });
  builder.addCase(addRoleToUser.fulfilled, (state, { payload }) => {
    state.addRoleToUserPending = false;
  });
  builder.addCase(addRoleToUser.rejected, (state, action) => {
    state.addRoleToUserPending = false;
  });
};
